module.exports = __webpack_public_path__ + "img/snore-record3.4aa5cdba.png";